<script setup>
// パスワード表示ボタン押下時
const onClickShowPasswordButton = (event) => {
  event.preventDefault();
  const buttonIconEl = event.target;
  const passwordEl = event.target.closest('.com_show_hide_password1').children[0];
  if (passwordEl.getAttribute('type') === 'text') {
    passwordEl.setAttribute('type', 'password');
    buttonIconEl.classList.add('icon_eye_slash1');
    buttonIconEl.classList.remove('icon_eye1');
  } else {
    passwordEl.setAttribute('type', 'text');
    buttonIconEl.classList.add('icon_eye1');
    buttonIconEl.classList.remove('icon_eye_slash1');
  }
}

// コンポーネントに渡されたpropsの取得
const props = defineProps({
  id: String,
  name: {type: String, default: ''},
  modelValue: String,
  placeholder: {type: String, default: ''},
  autocomplete: {type: String, default: 'current-password'},
  error: Boolean,
});

// コンポーネントに渡されたemitsの取得
const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="com_show_hide_password1">
    <input :id="props.id" type="password" :name="props.name" :autocomplete="props.autocomplete"
           :class="props.error ? 'form-control com_form1 s1 error' : 'form-control com_form1 s1'"
           :value="props.modelValue" @input="emit('update:modelValue', $event.target.value)"
           :placeholder="props.placeholder">
    <div class="com_show_hide_password_btn1">
      <a href="" @click="onClickShowPasswordButton">
        <i class="icon_eye_slash1" aria-hidden="true"></i>
      </a>
    </div>
  </div>
</template>

<style scoped>
::-ms-reveal {
  display: none;
}
</style>
